import React, { useEffect, useState } from "react";
import { DatePicker } from "antd";
import { useDispatch, useSelector } from "react-redux";
import dayjs from "dayjs";

import { AppDispatch, RootState } from "../../../../redux-store/store";
import {
  ILocalFilterValue,
  NotificationActions,
} from "../../../../slices/NotificationSlice";

import { GetAllNotification_M3 } from "../../../../api/notifyapi/Notifyapi";
import { ESearchFilterActiveTypes } from "../../../../constants/CommonInterfaces";
import {
  CategoryFilterOption,
  DBTilte,
  NOTIFICATION_FILTER_CONFIG,
} from "./ExtensiveFilterContent";

const { RangePicker } = DatePicker;

// Define types for filter configuration
export interface NotifyFilterConfig {
  label: string;
  key: string;
  type: "input" | "select" | "date";
  placeholder?: string;
  options?: CategoryFilterOption[];
}

interface IExtensiveProps {
  onClose: () => void;
}

const ExtensiveFilter: React.FC<IExtensiveProps> = ({ onClose }) => {
  const dispatch = useDispatch<AppDispatch>();
  const { apiQuery } = useSelector(
    (state: RootState) => state.notification.searchFilter
  );
  const lsearchQuery = useSelector(
    (state: RootState) => state.notification.searchFilter.columnSearch
  );
  const [isEnableSearch, setIsEnableSearch] = useState<boolean>(false);

  const handleInputChange = (field: string, value: string, dbField: string) => {
    setIsEnableSearch(false);
    dispatch(
      NotificationActions.UpdateLocalSearchQuery({ field, value: value })
    );
  };

  const handleDateRangeChange = (
    field: string,
    dates: any,
    localField: string
  ) => {
    setIsEnableSearch(false);
    const startDate = dates[0];
    const endDate = dates[1];
    let formatDate1;
    let formatDate2;

    let validateDate = "";
    let localSearchDate = "";

    if (startDate !== "" && endDate !== "") {
      formatDate1 = dayjs(startDate).format("YYYYMMDDHHMMss");
      formatDate2 = dayjs(endDate).format("YYYYMMDDHHMMss");
      validateDate = `${formatDate1}:${formatDate2}`;
      localSearchDate = dates;
    }

    if (dates.length !== 0) {
      dispatch(
        NotificationActions.UpdateLocalSearchQuery({
          field: localField,
          value: localSearchDate,
        })
      );
    }
  };

  // useEffect fucntion for search value sent to the after setting hte value
  useEffect(() => {
    if (isEnableSearch) {
      let lSearchQuery = Object.assign({}, apiQuery);

      lSearchQuery.filters = lSearchQuery.filters.filter((x) => {
        // Handle different types of values
        if (typeof x.value === "string") {
          // For strings, check if it's not an empty string after trimming
          return x.value.trim() !== "";
        }

        // For other types (numbers, etc.), check if the value is not null or undefined
        return x.value !== null && x.value !== undefined;
      });
      console.log("lSearchQuery: ", lSearchQuery);
      lSearchQuery.isOr = false;
      lSearchQuery.page = 1;

      dispatch(
        NotificationActions.UpdatePagination({
          page: 1,
          pageSize: apiQuery.pageSize,
          isPageChanged: false,
        })
      );

      dispatch(
        NotificationActions.UpdateGlobalSearchFilter({
          value: "",
        })
      );

      dispatch(
        NotificationActions.UpdateLastActiveSearch({
          value: ESearchFilterActiveTypes.column,
        })
      );

      dispatch(GetAllNotification_M3(lSearchQuery));
      setIsEnableSearch(false);
      onClose();
    }
  }, [isEnableSearch]);

  const handleApplyFilter = async () => {
    // Apply temp search values to actual search query
    dispatch(NotificationActions.ApplyColumnSearchFilter());
    setIsEnableSearch(true);
  };
  const handleClear = () => {
    setIsEnableSearch(false);
    dispatch(
      NotificationActions.ResetColumnSearchFilter({
        canClearAll: true,
        fieldClear: "",
        field2: "",
      })
    );
    let lSearchQuery = Object.assign({}, apiQuery);
    lSearchQuery.filters = [];
    lSearchQuery.isOr = false;
    lSearchQuery.page = 1;
    dispatch(
      NotificationActions.resetLocalSearchQuery({
        canClearAll: true,
        fieldClear: "",
      })
    );
    dispatch(GetAllNotification_M3(lSearchQuery));
    onClose();
  };

  return (
    <div style={styles.container}>
      <div style={styles.gridContainer}>
        {NOTIFICATION_FILTER_CONFIG.map((config) => (
          <div key={config.key} style={styles.filterRow}>
            <label htmlFor={config.key} style={styles.label}>
              {config.label}
            </label>

            {config.type === "input" ? (
              <input
                id={config.key}
                type="text"
                placeholder={config.placeholder}
                value={
                  lsearchQuery[config.key as keyof ILocalFilterValue].value
                }
                onChange={(e) =>
                  handleInputChange(
                    config.key,
                    e.target.value,
                    DBTilte[config.key as keyof ILocalFilterValue]
                  )
                }
                style={styles.input}
              />
            ) : config.type === "select" ? (
              <select
                value={
                  lsearchQuery[config.key as keyof ILocalFilterValue].value
                }
                onChange={(e) =>
                  handleInputChange(
                    config.key,
                    e.target.value,
                    DBTilte[config.key as keyof ILocalFilterValue]
                  )
                }
                style={styles.select}
              >
                <option value="" style={styles.options}>
                  Select {config.label}
                </option>
                {config.options?.map((option: any) => (
                  <option
                    key={option.value}
                    value={option.value}
                    style={styles.options}
                  >
                    {option.label}
                  </option>
                ))}
              </select>
            ) : (
              <div style={styles.datePickerContainer}>
                <RangePicker
                  value={
                    lsearchQuery[config.key as keyof ILocalFilterValue].value &&
                    lsearchQuery[config.key as keyof ILocalFilterValue].value
                      .length === 2
                      ? [
                          dayjs(
                            lsearchQuery[config.key as keyof ILocalFilterValue]
                              .value[0]
                          ),
                          dayjs(
                            lsearchQuery[config.key as keyof ILocalFilterValue]
                              .value[1]
                          ),
                        ]
                      : undefined
                  }
                  onChange={(dates: any, dateStrings: any) =>
                    handleDateRangeChange(
                      DBTilte[config.key as keyof ILocalFilterValue],
                      dateStrings,
                      config.key
                    )
                  }
                  format="YYYY/MM/DD"
                  style={styles.datePicker}
                />
              </div>
            )}
          </div>
        ))}
      </div>

      <div style={styles.buttonContainer}>
        <button onClick={handleClear} className="column-filter-clear-btn">
          Clear
        </button>
        <button
          className="popup-create-btn column-filter-search-btn"
          onClick={handleApplyFilter}
        >
          Search
        </button>
      </div>
    </div>
  );
};

// Styles using standard CSS-in-JS approach
const styles = {
  container: {
    padding: "24px",
    backgroundColor: "white",
    borderRadius: "8px",
    boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
  },
  gridContainer: {
    display: "grid",
    gridTemplateColumns: "315px 1fr",
    gap: "16px",
  },
  filterRow: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
  },
  label: {
    fontSize: "12px",
    fontWeight: 500,
    color: "#333",
    marginRight: "16px",
    minWidth: "90px",
    fontFamily: "DiscoverSans-Medium",
  },
  input: {
    width: "190px",
    flexGrow: 1,
    padding: "8px 12px",
    border: "1px solid #ccc",
    borderRadius: "4px",
    fontSize: "12px",
    outline: "none",
    fontFamily: "DiscoverSans-Medium",
  },
  select: {
    width: "190px",
    flexGrow: 1,
    outline: "none",
    padding: "8px 12px",
    border: "1px solid #ccc",
    borderRadius: "4px",
    fontSize: "12px",
    fontFamily: "DiscoverSans-Medium",
  },
  options: {
    fontSize: "10px",
    fontFamily: "DiscoverSans-Medium",
  },
  datePickerContainer: {
    border: "1px solid #ccc",
    borderRadius: "4px",
    padding: "8px 12px",
    width: "190px",
    flexGrow: 1,
  },
  datePicker: {
    width: "100%",
  },
  buttonContainer: {
    display: "flex",
    justifyContent: "flex-end",
    marginTop: "24px",
    gap: "16px",
  },
};

export default ExtensiveFilter;
